export const fonts = {
  heading: 'Clone Machine, sans-serif',
  body: 'Cairo, system-ui, sans-serif',
}
